import tooltipster from 'tooltipster';

jQuery(document).ready(function ($) {
    let $body = $("body");

    $('.tc__tooltip, .tc__tooltip a').each(function () {
        if ($(this).is("[title]")) {

            $(this).tooltipster({
                trigger: 'hover'
            });

            $(this).on( "focus", function() {
                $(this).tooltipster('open');
            });
            $(this).on( "blur", function() {
                $(this).tooltipster('close');
            });
        }
    });

    const darkmode = new Darkmode({
        saveInCookies: false,
        autoMatchOsTheme: false
    });

    $body.on("click", ".tc__header-contrast-trigger", function (e) {
        e.preventDefault();
        darkmode.toggle();
        console.log("Darkmode: " + darkmode.isActivated());
        Cookies.set('darkmode', darkmode.isActivated() ? 1 : 0, {expires: 30, path: '/'});
    })

    if (Cookies.get('darkmode') === "1") {
        darkmode.toggle();
    } else {
        $body.removeClass("darkmode--activated")
    }

    // Header Search-Form | Contact ------------------------------------------------------------------------------------
    let $triggerSearch = $('.tc__header-search-trigger'),
        $searchWrapper = $('#tc__header-search-wrapper'),
        $triggerContact = $('.tc__header-contact-trigger'),
        $contactWrapper = $('#tc__header-contact-wrapper');

    $triggerSearch.click(function (e) {
        e.preventDefault();

        let $input = $searchWrapper.find('.elementor-search-form__input');

        if ($triggerContact.hasClass('active')) {
            $contactWrapper.slideToggle(200);
            $triggerContact.removeClass('active');
        }

        $(this).toggleClass('active');
        $searchWrapper.slideToggle(200);
        $input.focus();
    });

    $triggerContact.click(function (e) {
        e.preventDefault();

        if ($triggerSearch.hasClass('active')) {
            $searchWrapper.slideToggle(200);
            $triggerSearch.removeClass('active');
        }
        $(this).toggleClass('active');
        $contactWrapper.slideToggle(200);
    });


    // Accessibility improvements
    // Accessibility improvements
    // Accessibility improvements

    // Allow disabling of animation
    let $lottie = $(".elementor-widget-lottie");
    $lottie.each(function () {
        let $thisLottie = $(this);

        $thisLottie.css("position", "relative");

        $thisLottie.append("<a href='#' class='tc-acc__pause-lottie' title='Animation deaktivieren'><i class='fa fa-times' aria-hidden='true'></i><span class='tc-acc__visually-hidden'>Animation deaktivieren</span></a>")
        let $pauseButton = $thisLottie.find(".tc-acc__pause-lottie");
        $pauseButton.on("click", function (e) {
            e.preventDefault();
            $thisLottie.find(".e-lottie__container").css("visibility", "hidden");
            $pauseButton.remove();
        })
    });

    // Add label to child
    let $labelElement = $(".tc-acc__add-label");
    $labelElement.each(function () {
        let $thisElement = $(this);

        let label = $thisElement.attr("data-a11ylabel")
        let selector = $thisElement.attr("data-a11yselector")

        if (!label || !selector || !$thisElement.find(selector).length) {
            return;
        }

        $thisElement.find(selector).attr("aria-label", label)
    })

    // Remove alt attributes from desired images in loops
    let $tcAccNoAlt = $(".tc-acc__no-alt");
    let $tcAccNoAltSelectors = [];
    $.each($tcAccNoAltSelectors, function (index, value) {
        $tcAccNoAlt = $tcAccNoAlt.add(value);
    })

    $tcAccNoAlt.each(function () {
        let $this = $(this);
        let $targetElement = $this;

        if (!$this.is("img")) {
            $targetElement = $this.find("img");
        }

        $targetElement.attr("alt", "")
        $targetElement.attr("title", "")
    });

    // Negative tabindex for screen readers/keyboard nav
    let $tcAccNoTab = $(".tc-acc__no-tab");
    let tcAccNoTabSelectors = [
        ".elementor-icon-box-icon",
        ".elementor-post__thumbnail__link",
        ".elementor-post__read-more",
    ];

    $.each(tcAccNoTabSelectors, function (index, value) {
        $tcAccNoTab = $tcAccNoTab.add(value);
    })

    $tcAccNoTab.each(function () {
        let $this = $(this);
        let $targetElement = $this;

        if (!$this.is("a")) {
            $targetElement = $this.find("a");
        }

        $targetElement.attr("aria-hidden", true)
        $targetElement.attr("tabindex", -1)

        if ($this.find("h1,h2,h3,h4,h5,h6").length) {
            $this.find("h1,h2,h3,h4,h5,h6").attr("aria-hidden", true)
        }
    });

    // Add #content id to main element
    if (!$("#content").length) {
        let selectors = [
            "[data-elementor-type=wp-page]",
            "[data-elementor-type=single-post]",
            "[data-elementor-type=search-results]",
        ];

        $body.find(selectors.join(",")).first().attr("id", "content");
    }

    // Jet Menu focus fix

    let itemClass = "jet-mega-menu-item";
    let itemClassMega = "jet-mega-menu-item--mega";
    let hoverClass = itemClass + "--hover";
    let containerClass = "jet-mega-menu-container";
    let linkSelector = "a.jet-mega-menu-item__link";

    // When the focus enters a menu item or anything within
    $(`.${itemClass}`).focusin(function () {
        // Clear out all hover items...
        $(`.${itemClass}`).removeClass(hoverClass);

        // Clear out all hover items...
        $(`.${itemClassMega}`).find(linkSelector).attr("aria-expanded", "false");

        let $targetElement;

        if ($(this).hasClass(itemClass)) {
            // If the focused item is the menu item
            $targetElement = $(this);
        } else {
            // If the focused item is anything else inside the menu item
            $targetElement = $(this).parents(itemClass);
        }

        // Add the hover class
        $targetElement.addClass(hoverClass);

        if ($targetElement.is(`.${itemClassMega}`)) {
            $targetElement.find(linkSelector).attr("aria-expanded", "true");
        }
    });

    // When the focus is in anything at all
    $body.focusin(function (e) {
        // If the focused item isn't within a 'jet-menu-container' parent
        if (!$(e.target).parents(`.${containerClass}`).length) {
            // Remove the hover class from all menu items
            $(`.${itemClass}`).removeClass(hoverClass);
            $(`.${itemClassMega}`).find(linkSelector).attr("aria-expanded", "false");
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === "Escape") {
            // write your logic here.
            // Remove the hover class from all menu itemsWW
            $(`.${itemClass}`).removeClass(hoverClass);
            $(`.${itemClassMega}`).find(linkSelector).attr("aria-expanded", "false");
        }
    });

    // Jet menu focus fix
    $(".jet-mega-menu-item__inner").removeAttr("tabindex");

    // Jet menu width fix
    setTimeout(() => {
        $(window).trigger("resize");
    }, 1000)

    const attributeReplacer = {
        config: {
            "popupCloseMenu": {
                selector: ".dialog-lightbox-close-button",
                attribute: "aria-label",
                targetType: "replace",
                targetValue: "Schließen",
            },
            "newsletterSocialLink": {
                selector: ".elementor-social-icons-wrapper .elementor-social-icon-envelope .elementor-screen-only",
                attribute: "rawText",
                targetType: "replace",
                targetValue: "Newsletter",
            },
            "lightboxImages": {
                selector: "[data-elementor-open-lightbox] img",
                attribute: "alt",
                targetType: "append",
                targetValue: " - öffnet vergrößerte Darstellung",
            },
            "borlabsCookieLogo": {
                selector: "#BorlabsCookieBox .cookie-logo",
                attribute: "alt",
                targetType: "replace",
                targetValue: "",
            },
        },
        initialise: function() {
            this.loopOverConfig();

            setInterval(() => {
                this.loopOverConfig();
            }, 1000)
        },
        loopOverConfig: function() {
            let config = this.config;
            $.each(config, function(name, config) {
                let $elements = $(config.selector + ":not([data-a11y-replaced])");

                if ($elements.length) {
                    $elements.each(function() {
                        let $element = $(this);

                        switch (config.attribute) {
                            case "rawText":
                                $element.text(config.targetValue);
                                break;
                            default:
                                let targetValue = config.targetValue;

                                if (config.targetType === "append") {
                                    targetValue = $element.attr(config.attribute) + targetValue;
                                } else if (config.targetType === "prepend") {
                                    targetValue = targetValue + $element.attr(config.attribute);
                                }

                                $element.attr(config.attribute, targetValue);
                                break;
                        }

                        $element.attr("data-a11y-replaced", "1");
                    })
                }
            })
        }
    }

    attributeReplacer.initialise();


    // Kiosk Mode and PDF Preview Popup
    // Kiosk Mode and PDF Preview Popup
    // Kiosk Mode and PDF Preview Popup
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const kioskModeOn = urlParams.has('kiosk');
    const kioskModeOff = urlParams.has('kioskOff');
    const kioskCookieName = "vmskioskmode";

    const allowedOrigins = [
        "https://www.vms.de",
        "http://www.vms.de",
        "http://vms.de",
        "https://vms.de",
        //"https://deutschlandticket.vms.de",
    ]

    const allowedIFrameOrigins = [
        "https://www.vms.de",
        "http://www.vms.de",
        "http://vms.de",
        "https://vms.de",
        "https://efa.vvo-online.de",
        "https://newassets.hcaptcha.com"
    ]

    const disAllowedExtensions = [
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
        ".zip",
    ]

    if (kioskModeOn) {
        console.log("Kiosk mode turned on!");
        Cookies.set(kioskCookieName, 1, {expires: 365, path: '/'});
    } else if (kioskModeOff) {
        console.log("Kiosk mode turned off!");
        Cookies.remove(kioskCookieName, {path: '/'});
    }

    console.log(Cookies.get(kioskCookieName));

    if (Cookies.get(kioskCookieName) === "1") {

        const maxIdleMinutes = 5;

        const selectorToHide = "body:not(.elementor-editor-active) .vms-kiosk__hide:visible";
        const targetUrl = "https://www.vms.de/kiosk/?kiosk=1";

        const enableKioskMode = () => {

            const screenSaver = {
                init: () => {
                    screenSaver.hide();
                },

                show: () => {
                    let $body = $("body");
                    if ($body.is(".elementor-editor-active")) {
                        return;
                    }

                    let $screenSaver = $body.find(".vms-kiosk__screensaver");
                    if ($screenSaver.length) {
                        $screenSaver.css("position", "fixed").css("inset", 0).css("z-index", "9999999")
                        $body.css("overflow-y", "hidden");
                    }
                },

                hide: () => {
                    let $body = $("body");
                    if ($body.is(".elementor-editor-active")) {
                        return;
                    }

                    let $screenSaver = $body.find(".vms-kiosk__screensaver");
                    if ($screenSaver.length) {
                        $screenSaver.css("position", "fixed").css("left", "999999px");
                        $body.css("overflow-y", "auto");
                    }
                },
            }

            const runIdleRedirect = () => {

                let idleTime = 0;
                console.log("Running Idle Timer");

                screenSaver.init();

                let timerIncrement = () => {
                    idleTime++;
                    console.log(`Idle for ${idleTime} minutes`);
                    if (idleTime >= maxIdleMinutes) {

                        //Only redirect if not on kiosk landing page
                        if (window.location.href === targetUrl) {
                            screenSaver.show();
                        } else {
                            window.location = targetUrl;
                        }
                    }
                }

                // Increment the idle time counter every minute.
                let idleInterval = setInterval(timerIncrement, 60000); // 1 minute

                // Zero the idle timer on mouse movement.
                $(document).on("mousemove keypress", function (e) {
                    idleTime = 0;
                    screenSaver.hide();
                });
            }

            const checkLinks = () => {
                let $links = $("a:not([data-originchecked])");
                let externalTargets = [];

                $links.each(function () {
                    let $link = $(this);
                    let linkTarget = $link.attr("href");
                    let isAllowed;
                    $link.attr("data-originchecked", "1");

                    try {
                        isAllowed = allowedOrigins.includes(new URL(linkTarget).origin);

                        // Check if it's a disallowed file extension
                        if (isAllowed) {
                            isAllowed = !disAllowedExtensions.some(substring => linkTarget.includes(substring))
                        }
                    } catch (_) {
                        isAllowed = true;
                    }

                    // Open PDF files in PDFJS viewer in featherlight modal
                    if (linkTarget.indexOf(".pdf") > -1) {
                        let viewerUrl = window.location.origin + "/pdfjs_kiosk/viewer/viewer.html";
                        viewerUrl = new URL(viewerUrl);
                        viewerUrl.searchParams.append("file", linkTarget);
                        $link.attr("data-featherlight", "iframe");

                        $link.off();
                        $link.on("click", function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            $.featherlight({
                                closeIcon: "Dokument schließen &#10005;",
                                variant: "vms-kiosk__featherlight",
                                iframe: viewerUrl,
                                iframeMaxWidth: '90vw',
                                iframeWidth: window.innerWidth * .85,
                                iframeHeight: window.innerHeight * .85,
                                afterOpen: () => {
                                    $(".featherlight-content").append(`<div class='featherlight-title'>${$link.text()}</div>`)
                                }
                            });
                        });
                    }

                    if (!isAllowed) {
                        externalTargets.push(linkTarget);

                        $link.attr("href", "#")
                        $link.on("click", function (e) {
                            e.preventDefault();
                            alert("Externe Links sind aus Sicherheitsgründen nicht verfügbar.")
                        })
                    }
                });

                if (externalTargets.length) {
                    console.log(externalTargets)
                }
            }

            const hideElements = () => {
                $(selectorToHide).hide();

                let externalIFrameTargets = [];

                $("iframe:not([data-originchecked])").each(function () {
                    let sameOrigin;
                    let $iFrame = $(this);

                    try {
                        const iframeSrc = $iFrame.attr("src");
                        const iFrameOrigin = new URL(iframeSrc).origin;
                        sameOrigin = allowedIFrameOrigins.includes(iFrameOrigin);
                    } catch (_) {
                        sameOrigin = false;
                    }

                    $iFrame.attr("data-originchecked", 1);

                    if (!sameOrigin) {
                        externalIFrameTargets.push($iFrame.attr("src"));

                        $iFrame.attr("src", "about:blank");
                    }
                });
                if (externalIFrameTargets.length) {
                    console.log(externalIFrameTargets)
                }
            }

            const runChecks = () => {
                checkLinks();
                hideElements();
            }

            setInterval(() => {
                runChecks()
            }, 500)

            runIdleRedirect();
        }

        enableKioskMode();
    } else {
        // PDF Preview Popup
        // PDF Preview Popup
        // PDF Preview Popup

        const checkPDFLinks = () => {
            let $links = $("a[href$='.pdf']:not([data-featherlighted])");
            let isMobile = window.matchMedia("(max-width: 768px)")

            if (isMobile.matches) {
                return;
            }

            $links.each(function () {
                let $link = $(this);
                let linkTarget = $link.attr("href");
                let canBeIFramed;
                $link.attr("data-featherlighted", "1");

                try {
                    canBeIFramed = allowedOrigins.includes(new URL(linkTarget).origin);
                } catch (_) {
                    canBeIFramed = false;
                }

                if (canBeIFramed) {
                    // Open PDF files in PDFJS viewer in featherlight modal
                    let viewerUrl = window.location.origin + "/pdfjs/viewer/viewer.html";
                    viewerUrl = new URL(viewerUrl);
                    viewerUrl.searchParams.append("file", linkTarget);
                    $link.attr("data-featherlight", "iframe");

                    $link.off();
                    $link.on("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        $.featherlight({
                            closeIcon: "Dokument schließen &#10005;",
                            variant: "vms-kiosk__featherlight",
                            iframe: viewerUrl,
                            iframeMaxWidth: '90vw',
                            iframeWidth: window.innerWidth * .85,
                            iframeHeight: window.innerHeight * .85,
                            afterOpen: () => {
                                $(".featherlight-content").append(`<div class='featherlight-title'>${$link.text()}</div>`)
                            }
                        });
                    });
                }
            });
        }

        // 240410 deactivate temporarily
        //checkPDFLinks();

        // Using jQuery to select all anchor tags that end with '.pdf'
        $('a[href$=".pdf"]').attr('target', '_blank');
    }
});